
export default function WhyUs() {
  const features = [
    {
      icon: 'ri-restaurant-line',
      title: 'بوفيه فطور مفتوح',
      description: 'استمتع ببوفيه مفتوح يوميًا يضم أكثر من 100 صنف من المأكولات المحلية والعالمية الطازجة',
      gradient: 'from-teal-500 to-teal-600'
    },
    {
      icon: 'ri-restaurant-2-line',
      title: 'قوائم متنوعة',
      description: 'قوائم غداء وعشاء غنية بالأطباق الشرقية والعالمية المحضرة بأيدي طهاة محترفين',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-leaf-line',
      title: 'مكونات طازجة',
      description: 'نستخدم أجود المكونات الطازجة المختارة بعناية لضمان أعلى جودة وأفضل مذاق',
      gradient: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-team-line',
      title: 'طهاة محترفون',
      description: 'فريق من الطهاة المحترفين ذوي الخبرة الواسعة في المطابخ المحلية والعالمية',
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-building-line',
      title: 'أجواء فندقية راقية',
      description: 'تصميم عصري أنيق مع إطلالات رائعة وأجواء مريحة تناسب جميع المناسبات',
      gradient: 'from-pink-500 to-rose-600'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'خدمة متميزة',
      description: 'فريق خدمة محترف يقدم تجربة ضيافة فندقية استثنائية على مدار اليوم',
      gradient: 'from-amber-500 to-amber-600'
    }
  ];

  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-orange-400 to-teal-500 rounded-2xl shadow-lg">
            <i className="ri-medal-line text-5xl text-white"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            لماذا تختار مطعمنا
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-400 to-teal-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            نجمع بين الجودة العالية والخدمة المتميزة لنقدم لك تجربة فطور لا تُنسى
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500/5 to-orange-400/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="relative">
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${feature.gradient} rounded-xl shadow-lg mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  {feature.title}
                </h3>
                
                <p className="text-gray-700 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-teal-500 to-orange-400 rounded-2xl p-1 shadow-lg">
            <div className="bg-white rounded-xl px-8 py-6">
              <p className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-orange-500" style={{ fontFamily: 'Cairo, sans-serif' }}>
                انضم إلى آلاف الضيوف الراضين واستمتع بتجربة فطور استثنائية
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
